

















































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"MentionsLegales",
  components: {    
  },
})
export default class MentionsLegales extends Vue {}
